// Constantes opções de selects dos componentes de formulários das práticas

export const opcoesGrauDegradacao = [
  {id: 'EM_BOAS_CONDICOES', nome: 'Em boas condições'},
  {id: 'LEVE', nome: 'Leve'},
  {id: 'MODERADO', nome: 'Moderado'},
  {id: 'SEVERO', nome: 'Severo'},
  {id: 'NAO_SEI_INFORMAR', nome: 'Não sei informar'}
]

export const opcoesSimNao = [
  {id: true, nome: 'Sim'},
  {id: false, nome: 'Não'}
]

export const opcoesSimNaoNaoSei = [
  {id: 'SIM', nome: 'Sim'},
  {id: 'NAO', nome: 'Não'},
  {id: 'NAO_SEI_RESPONDER', nome: 'Não sei responder'}
]

export const opcoesTecnicaRecuperacao = [
  {id: 'ADUBACAO', nome: 'Adubação'},
  {id: 'CALAGEM', nome: 'Calagem'},
  {id: 'CONTROLE_PLANTAS_INVASORAS', nome: 'Controle de plantas invasoras'},
  {id: 'MANEJO_ROTACIONADO', nome: 'Manejo rotacionado'},
  {id: 'RESTAURACAO_COBERTURA_VEGETAL', nome: 'Restauração de cobertura vegetal'},
  {id: 'RENOVACAO_PASTAGEM', nome: 'Renovação da pastagem'},
  {id: 'REPLANTIO_FORRAGEIRAS', nome: 'Replantio de forrageiras'},
  {id: 'NAO_SEI_INFORMAR', nome: 'Não sei informar'},
  {id: 'OUTROS', nome: 'Outros'}
]

export const opcoesBioinsumo = [
  {id: 'BIODEFENSIVOS', nome: 'Biodefensivos'},
  {id: 'BIOFERTILIZANTES', nome: 'Biofertilizantes'},
  {id: 'COMPOSTOS_ORGANICOS', nome: 'Compostos orgânicos'},
  {id: 'INOCULANTES_BIOLOGICOS', nome: 'Inoculantes biológicos'},
  {id: 'PRODUTOS_HOMEOPATICOS_FITOTERAPICOS', nome: 'Produtos homeopáticos / fitoterápicos'},
  {id: 'OUTROS', nome: 'Outros'}
]

export const opcoesTipoSistemaIrrigacao = [
  {id: 'ASPERSAO', nome: 'Aspersão'},
  {id: 'GOTEJAMENTO', nome: 'Gotejamento'},
  {id: 'MICROASPERSAO', nome: 'Microaspersão'},
  {id: 'PIVO_CENTRAL', nome: 'Pivô central'},
  {id: 'SULCO_OU_CANAL', nome: 'Sulco/canal'},
  {id: 'OUTRO', nome: 'Outro'}
]

export const opcoesFonteAguaUtilizada = [
  {id: 'SUBTERRANEA', nome: 'Subterrânea'},
  {id: 'SUPERFICIAL_RIO_BAIXO_AMAZONAS', nome: 'Superficial - (Rio) Baixo Amazonas'},
  {id: 'SUPERFICIAL_RIO_CALHA_NORTE', nome: 'Superficial - (Rio) Calha Norte'},
  {id: 'SUPERFICIAL_RIO_COSTA_ATLANTICA_NORDESTE', nome: 'Superficial - (Rio) Costa Atlântica-Nordeste'},
  {id: 'SUPERFICIAL_RIO_PORTEL_MARAJO', nome: 'Superficial - (Rio) Portel-Marajó'},
  {id: 'SUPERFICIAL_RIO_TAPAJOS', nome: 'Superficial - (Rio) Tapajós'},
  {id: 'SUPERFICIAL_RIO_TOCANTINS_ARAGUAIA', nome: 'Superficial - (Rio) Tocantins-Araguaia'},
  {id: 'SUPERFICIAL_RIO_XINGU', nome: 'Superficial - (Rio) Xingu'},
  {id: 'LAGOS', nome: 'Lagos'},
  {id: 'RESERVATORIOS_ARTIFICIAIS', nome: 'Reservatórios artificiais'},
  {id: 'OUTRO', nome: 'Outro'}
]

export const opcoesCaptacaoLicenciada = [
  {id: 'SIM', nome: 'Sim'},
  {id: 'NAO', nome: 'Não'},
  {id: 'EM_REGULARIZACAO', nome: 'Em regularização'}
]

export const opcoesFonteFinanciamento = [
  {id: 'RECURSO_PROPRIO', nome: 'Recurso próprio'},
  {id: 'CREDITO_RURAL', nome: 'Crédito rural'},
  {id: 'OUTRO', nome: 'Outro'}
]

export const opcoesTipoTratamento = [
  {id: 'COMPOSTAGEM', nome: 'Compostagem'},
  {id: 'BIODIGESTOR', nome: 'Biodigestor (produção de biogás)'},
  {id: 'TANQUE_ESTABILIZACAO_LAGOA_ANAEROBIA', nome: 'Tanque de estabilização / lagoa anaeróbica'},
  {id: 'SEPARACAO_SOLIDO_LIQUIDO', nome: 'Separação sólido-líquido'},
  {id: 'OUTROS', nome: 'Outros'}
]

export const opcoesAproveitamentoResiduos = [
  {id: 'FERTIRRIGACAO', nome: 'Fertirrigação'},
  {id: 'BIOFERTILIZANTE', nome: 'Biofertilizante'},
  {id: 'BIOGAS', nome: 'Geração de energia (biogás)'},
  {id: 'REUSO_PROPRIEDADE', nome: 'Reuso na propriedade'},
  {id: 'VENDA_TERCEIROS', nome: 'Venda para terceiros'},
  {id: 'OUTROS', nome: 'Outros'}
]

export const opcoesTipoManejo = [
  {id: 'CONFINADO', nome: 'Confinado'},
  {id: 'SEMI_CONFINADO', nome: 'Semi-confinado'},
  {id: 'EXTENSIVO_OU_PASTOREIO', nome: 'Extensivo / pastoreio'}
]

export const opcoesTipoCriacao = [
  {id: 'BOVINOS', nome: 'Bovinos'},
  {id: 'SUINOS', nome: 'Suínos'},
  {id: 'AVES', nome: 'Aves'},
  {id: 'CAPRINOS_OVINOS', nome: 'Caprinos/ovinos'},
  {id: 'OUTROS', nome: 'Outros'}
]

export const opcoesTipoSistemaTI = [
  {id: 'CONFINAMENTO', nome: 'Confinamento total'},
  {id: 'SEMI_CONFINAMENTO', nome: 'Semi-confinamento'},
  {id: 'PASTO_COM_SUPLEMENTACAO_INTENSIVA', nome: 'Pasto com suplementação intensiva'},
  {id: 'OUTROS', nome: 'Outros'}
]

export const opcoesTipoAlimentacao = [
  {id: 'VOLUMOSO_E_CONCENTRADO', nome: 'Volumoso + concentrado'},
  {id: 'SILAGEM', nome: 'Silagem'},
  {id: 'RACAO_FORMULADA', nome: 'Ração formulada'},
  {id: 'SUBPRODUTOS', nome: 'Subprodutos (bagaço, polpa cítrica etc.)'},
  {id: 'OUTROS', nome: 'Outros'}
]

export const opcoesEspecies = [
  { id: 'BOVINOS', nome: 'Bovinos' },
  { id: 'OVINOS', nome: 'Ovinos' },
  { id: 'CAPRINOS', nome: 'Caprinos' },
  { id: 'OUTROS', nome: 'Outros' }
]

export const opcoesFinalidadeFloresta = [
  {id: 'COMERCIAL', nome: 'Comercial (produção de madeira, carvão etc.)'},
  {id: 'RECUPERACAO_AMBIENTAL', nome: 'Recuperação ambiental'},
  {id: 'PROTECAO_APP_OU_RL', nome: 'Proteção de APP ou RL'},
  {id: 'OUTROS', nome: 'Outros / quais'}
]

export const opcoesEspeciesFlorestais = [
  {id: 'EUCALIPTO', nome: 'Eucalipto'},
  {id: 'TECA', nome: 'Teca'},
  {id: 'PARICA', nome: 'Paricá'},
  {id: 'MOGNO', nome: 'Mogno'},
  {id: 'CASTANHEIRA', nome: 'Castanheira'},
  {id: 'SERINGUEIRA', nome: 'Seringueira'},
  {id: 'OUTROS', nome: 'Outros / quais'}
]

export const opcoesEspeciesFlorestaisSaf = [
  {id: 'CASTANHA_DO_PARA', nome: 'Castanha do Pará', nomeCientifico: 'Bertholletia excelsa'},
  {id: 'FREIJO', nome: 'Freijó', nomeCientifico: 'Cordia goeldiana'},
  {id: 'MOGNO_AFRICANO', nome: 'Mogno africano', nomeCientifico: 'Khaya ivorensis'},
  {id: 'TAXI_BRANCO', nome: 'Taxi-branco', nomeCientifico: 'Tachigali vulgaris'},
  {id: 'ANDIROBA', nome: 'Andiroba', nomeCientifico: 'Carapa guianensis'},
  {id: 'CEDRO', nome: 'Cedro', nomeCientifico: 'Cedrela fissilis'},
  {id: 'CUMARU', nome: 'Cumaru', nomeCientifico: 'Dipterex odorata'},
  {id: 'UXI', nome: 'Uxi', nomeCientifico: 'Endopleura uchi'},
  {id: 'PARICA', nome: 'Paricá', nomeCientifico: 'Schizolobium amazonicum'},
  {id: 'ACAPU', nome: 'Acapu', nomeCientifico: 'Vouacapoua amaricana'},
  {id: 'COPAIBA', nome: 'Copaíba', nomeCientifico: 'Copaifera langsdorffii'},
  {id: 'TATAJUBA', nome: 'Tatajuba', nomeCientifico: 'Bagassa guianensis'},
  {id: 'CUPIUBA', nome: 'Cupiúba', nomeCientifico: 'Goupia glabra'},
  {id: 'MARANHOTO', nome: 'Maranhoto', nomeCientifico: 'Bombacopsis glabra'},
  {id: 'MOROTOTO', nome: 'Morototó', nomeCientifico: 'Schefflera morototoni'},
  {id: 'IPE', nome: 'Ipê', nomeCientifico: 'Tabebuia sp'},
  {id: 'VIROLA', nome: 'Virola', nomeCientifico: 'Virola surinamensis'},
  {id: 'MULATEIRO', nome: 'Mulateiro', nomeCientifico: 'Calycophyllum spruceanum'},
  {id: 'AMARELAO', nome: 'Amarelão', nomeCientifico: 'Apuleia leiocarpa'},
  {id: 'MACACAPORANGA', nome: 'Macacaporanga', nomeCientifico: 'Aniba parviflora'},
  {id: 'JATOBA', nome: 'Jatobá', nomeCientifico: 'Hymenaea courbaril'},
  {id: 'PIQUIA', nome: 'Piquiá', nomeCientifico: 'Caryocar villosum'},
  {id: 'OUTROS', nome: 'Outros(as)'}
]

export const opcoesEspeciesFrutiferas = [
  {id: 'ACAI', nome: 'Açaí', nomeCientifico: 'Euterpe oleracea'},
  {id: 'CACAU', nome: 'Cacau', nomeCientifico: 'Theobroma cacao'},
  {id: 'PUPUNHA', nome: 'Pupunha', nomeCientifico: 'Bactris gasipaes'},
  {id: 'JENIPAPO', nome: 'Jenipapo', nomeCientifico: 'Genipa americana'},
  {id: 'TAPEREBA', nome: 'Taperebá', nomeCientifico: 'Spondias lutea'},
  {id: 'BACURI', nome: 'Bacuri', nomeCientifico: 'Platonia insignis'},
  {id: 'BACABA', nome: 'Bacaba', nomeCientifico: 'Oenocarpus mapora'},
  {id: 'CAFE', nome: 'Café', nomeCientifico: 'Coffea sp'},
  {id: 'BIRIBA', nome: 'Biribá', nomeCientifico: 'Rollinia mucosa'},
  {id: 'GUARANA', nome: 'Guaraná', nomeCientifico: 'Paullinia cupana'},
  {id: 'CUPUACU', nome: 'Cupuaçu', nomeCientifico: 'Theobroma grandiflorum'},
  {id: 'DENDE', nome: 'Dendê', nomeCientifico: 'Elaesis guieensis'},
  {id: 'BURITI', nome: 'Buriti', nomeCientifico: 'Mauritia flexuosa'},
  {id: 'ABACATE', nome: 'Abacate', nomeCientifico: 'Persea amaricana'},
  {id: 'OUTROS', nome: 'Outros(as)'}
]

export const opcoesEspeciesCicloCurto = [
  {id: 'URUCUM', nome: 'Urucum', nomeCientifico: 'Bixa oellana'},
  {id: 'BANANA', nome: 'Banana', nomeCientifico: 'Musa sp'},
  {id: 'MACAXEIRA_MANDIOCA', nome: 'Macaxeira/Mandioca', nomeCientifico: 'Manihot esculenta'},
  {id: 'MAMAO', nome: 'Mamão', nomeCientifico: 'Carica papaya'},
  {id: 'MARACUJA', nome: 'Maracujá', nomeCientifico: 'Passiflora edulis'},
  {id: 'MILHO', nome: 'Milho', nomeCientifico: 'Zea mays'},
  {id: 'ABACAXI', nome: 'Abacaxi', nomeCientifico: 'Ananas comosus'},
  {id: 'BATATA_DOCE', nome: 'Batata doce', nomeCientifico: 'Ipomoea batatas'},
  {id: 'CARA', nome: 'Cará', nomeCientifico: 'Dioscorea alata'},
  {id: 'INHAME', nome: 'Inhame', nomeCientifico: 'Dioecorea cayanensis'},
  {id: 'ARIA', nome: 'Ariá', nomeCientifico: 'Calathea allouia'},
  {id: 'GENGIBRE', nome: 'Gengibre', nomeCientifico: 'Zingiber officinale'},
  {id: 'ARARUTA', nome: 'Araruta', nomeCientifico: 'Maranta arundinacea'},
  {id: 'CURCUMA', nome: 'Cúrcuma', nomeCientifico: 'Curcuma longa'},
  {id: 'PIMENTA_DO_REINO', nome: 'Pimenta do reino', nomeCientifico: 'Piper nigrum'},
  {id: 'PIMENTINHA', nome: 'Pimentinha', nomeCientifico: 'Capcisum chinense'},
  {id: 'FEIJAO_CAUPI', nome: 'Feijão caupi', nomeCientifico: 'Vigna unguiculata'},
  {id: 'OUTROS', nome: 'Outros(as)'}
]

export const opcoesEspeciesAdubadeiras = [
  {id: 'GLIRICIDIA', nome: 'Gliricídia', nomeCientifico: 'Gliricídia sepium'},
  {id: 'INGA', nome: 'Ingá', nomeCientifico: 'Inga edulis'},
  {id: 'PALHETEIRA', nome: 'Palheteira', nomeCientifico: 'Clitoria fairchildiana'},
  {id: 'FEIJAO_DE_PORCO', nome: 'Feijão de porco', nomeCientifico: 'Canavalia ensiformis'},
  {id: 'FEIJAO_GUANDU', nome: 'Feijão guandu', nomeCientifico: 'Cajanus cajan'},
  {id: 'MARGARIDAO', nome: 'Margaridão', nomeCientifico: 'Tithonia diversifolia'},
  {id: 'AMENDOIM_FORRAGEIRO', nome: 'Amendoim forrageiro', nomeCientifico: 'Arachis pintoi'},
  {id: 'CROTALARIA', nome: 'Crotalária', nomeCientifico: 'Crotalaria juncea'},
  {id: 'OUTROS', nome: 'Outros(as)'}
]

export const opcoesDestinacaoUsoImovel = [
  {id: 'AGRICULTURA', nome: 'Agricultura'},
  {id: 'PASTAGEM', nome: 'Pastagem'},
  {id: 'VEGETACAO_NATIVA', nome: 'Vegetação nativa'},
  {id: 'AREA_CONTRUIDA_OU_MORADIA', nome: 'Área construída/moradia'},
  {id: 'SERVIDAO_AMBIENTAL', nome: 'Servidão ambiental'},
  {id: 'REFLORESTAMENTO', nome: 'Reflorestamento'},
  {id: 'OUTRO', nome: 'Outro'}
]

export const orgaosOptions = [
  { id: 'EMATER', nome: 'Emater' },
  { id: 'FAEPA', nome: 'Faepa' },
  { id: 'FETAGRI', nome: 'Fetagri' },
  { id: 'FETRAFI', nome: 'Fetrafi' },
  { id: 'SUZANO', nome: 'Suzano' },
  { id: 'JBS', nome: 'Jbs' },
  { id: 'OUTROS', nome: 'Outros' }
]

export const modalidades = [
  { id: 'LAVOURA_E_PECUARIA', nome: 'Lavoura + Pecuária' },
  { id: 'LAVOURA_E_FLORESTA', nome: 'Lavoura + Floresta' },
  { id: 'PECUARIA_E_FLORESTA', nome: 'Pecuária + Floresta' },
  { id: 'LAVOURA_PECUARIA_E_FLORESTA', nome: 'Lavoura + Pecuária + Floresta (completa)' },
  { id: 'NAO_SEI_INFORMAR', nome: 'Não sei informar' }
]

export const culturas = [
  { id: 'MILHO', nome: 'Milho' },
  { id: 'SOJA', nome: 'Soja' },
  { id: 'ARROZ', nome: 'Arroz' },
  { id: 'FEIJAO', nome: 'Feijão' },
  { id: 'TRIGO', nome: 'Trigo' },
  { id: 'SORGO', nome: 'Sorgo' },
  { id: 'OUTROS', nome: 'Outros/quais' }
]

export const tiposCriacao = [
  { id: 'BOVINOCULTURA_DE_CORTE', nome: 'Bovinocultura de corte' },
  { id: 'BOVINOCULTURA_LEITEIRA', nome: 'Bovinocultura Leiteira' },
  { id: 'OVINOS', nome: 'Ovinos' },
  { id: 'OUTROS', nome: 'Outros/quais' }
]

export const especiesFlorestais = [
  { id: 'EUCALIPTO', nome: 'Eucalipto' },
  { id: 'TECA', nome: 'Teca' },
  { id: 'PARICA', nome: 'Paricá' },
  { id: 'MOGNO', nome: 'Mogno' },
  { id: 'CASTANHEIRA', nome: 'Castanheira' },
  { id: 'SERINGUEIRA', nome: 'Seringueira' },
  { id: 'OUTROS', nome: 'Outros/quais' }
]

export const tipoCoberturaVegetal = [
  { id: 'PALHADA', nome: 'Palhada' },
  { id: 'ADUBACAO_VERDE', nome: 'Adubação verde' },
  { id: 'RESIDUOS_CULTURAIS', nome: 'Resíduos culturais' },
  { id: 'OUTRA', nome: 'Outra' },
  { id: 'NAO_SEI_INFORMAR', nome: 'Não sei informar' }
]



// WEBPACK FOOTER //
// ./src/libs/constants/praticas/opcoesSelects.js